import styled from "@emotion/styled";

export const ShippingMethodsContainer = styled.section`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${({ theme }) => theme.space.space24};
  padding-block-end: ${({ theme }) => theme.space.space32};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-block-end: 0;
  }
`;

export const ShippingMethodsList = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.space24};
  grid-template-columns: minmax(0, 1fr);
`;

export const ShippingMethodItem = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: ${({ theme }) => theme.space.space16};
  align-items: center;
  padding: ${({ theme }) => theme.space.space16};
  border: 1px solid ${({ theme }) => theme.colors.tone.silver};
  border-radius: ${({ theme }) => theme.space.space8};
  cursor: pointer;

  &.selected {
    background-color: ${({ theme }) => theme.colors.tone.sand};

    .info .label {
      font-weight: 600;
    }
  }

  &.pudo {
    &.selected {
      row-gap: ${({ theme }) => theme.space.space16};
    }
  }

  .info {
    display: flex;
    place-items: center;
    gap: ${({ theme }) => theme.space.space16};

    .content {
      display: flex;
      flex-direction: column;
    }

    .label {
      color: ${({ theme }) => theme.colors.tone.black};
    }
  }
`;

export const ShippingMethodLabel = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const PudoSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space.space8};
  background-color: ${({ theme }) => theme.colors.tone.sand};
  padding: ${({ theme }) => theme.space.space16};
`;
